import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled from "@emotion/styled-base";
// @ts-check
import React from "react";
import DefaultTrivia from "../DefaultTrivia";
import { defineTrivia } from "../defineTrivia";
import { CONTAINER_TRIVIA_BEGIN } from "../positions";
import { portrait } from "../../styles/media-queries";
import { jsx as _jsx } from "react/jsx-runtime";
var Audio = /*#__PURE__*/_styled("audio", {
  target: "e1tg2aau0",
  label: "Audio"
})(_defineProperty({
  display: "block",
  width: "calc(100% - 30px)",
  margin: "10px auto"
}, "@media".concat(portrait), {
  width: "100%"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

// render a trivia at the default trivia position
export default defineTrivia({
  getPosition: function getPosition() {
    return CONTAINER_TRIVIA_BEGIN;
  },
  /**
   * NOTE: the next line is not necessary, but if you have custom props, use it
   * @param {import("../defineTrivia").CommonTriviaProps & {
   *  customProp: any
   * }} props
   */
  Component: function Component(props) {
    var content = props.content;
    var _ref = content || {},
      expert = _ref.expert,
      file = _ref.file;
    if (!file) {
      return null;
    }

    // if (expert) {
    //   props = {
    //     ...props,
    //     thumbnail: `/img/experts/crop_${expert.picture}`,
    //     thumbnailTitle: expert.name,
    //     header: (
    //       <>
    //         <strong>{expert.name}, </strong> <span>{expert.profession}</span>
    //       </>
    //     ),
    //     headerBottom: true,
    //   }
    // }

    return /*#__PURE__*/_jsx(DefaultTrivia, _objectSpread(_objectSpread({}, props), {}, {
      className: "trivia-audio",
      children: /*#__PURE__*/_jsx(Audio, {
        src: file,
        controls: true
      })
    }));
  }
});
//# sourceMappingURL=Audio.js.map